(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-gallery')) {
    class ImageGallery extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.list = this.querySelector('[data-ig-list]');
        this.items = Array.from(this.querySelectorAll('[data-ig-item]'));
        this.filters = Array.from(this.querySelectorAll('[data-ig-filter]'));
        this.moreBtn = this.querySelector('[data-ig-more]');
        this.prevBtn = this.querySelector('[data-ig-prev]');
        this.nextBtn = this.querySelector('[data-ig-next]');
        this.dialog = this.querySelector('[data-ig-dialog]');

        this.initial = parseInt(this.dataset.initial, 10) || 0;
        this.step = parseInt(this.dataset.step, 10) || this.initial || 8;
        this.shown = this.initial;
        this.active = 'all';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.filters.forEach((btn) => btn.addEventListener('click', () => this.setFilter(btn)));
        if (this.moreBtn) this.moreBtn.addEventListener('click', () => this.loadMore());

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollSlides(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollSlides(1));
        if (this.list && this.prevBtn) {
          this.list.addEventListener('scroll', () => requestAnimationFrame(() => this.updateArrows()), { passive: true });
          window.addEventListener('resize', (this._onResize = () => this.updateArrows()));
        }

        if (this.dialog) this.setupLightbox();
        this.render();
        this.setupEntrance();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        document.documentElement.style.overflow = '';
        this._init = false;
      }

      /* ---------- Filtering + load more ---------- */
      matching() {
        return this.items.filter((el) => {
          if (this.active === 'all') return true;
          return (el.dataset.categories || '').split('|').includes(this.active);
        });
      }

      setFilter(btn) {
        this.active = btn.dataset.igFilter;
        this.shown = this.initial;
        this.filters.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        this.render();
      }

      render() {
        const matches = this.matching();
        const limit = this.initial ? this.shown : Infinity;
        this.items.forEach((el) => {
          const idx = matches.indexOf(el);
          el.hidden = idx === -1 || idx >= limit;
        });
        if (this.moreBtn) this.moreBtn.hidden = matches.length <= limit;
        this.updateArrows();
      }

      loadMore() {
        const matches = this.matching();
        const previous = this.shown;
        this.shown += this.step;
        this.render();
        const first = matches[previous];
        const focusable = first && first.querySelector('a, button');
        if (focusable) focusable.focus();
      }

      /* ---------- Carousel ---------- */
      scrollSlides(direction) {
        const first = this.items.find((el) => !el.hidden);
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const slideWidth = first.getBoundingClientRect().width + gap;
        const perPage = Math.max(1, Math.floor(this.list.clientWidth / slideWidth));
        this.list.scrollBy({ left: direction * slideWidth * perPage, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      updateArrows() {
        if (!this.prevBtn || !this.nextBtn || !this.list) return;
        const l = this.list;
        this.prevBtn.disabled = l.scrollLeft <= 1;
        this.nextBtn.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 1;
      }

      /* ---------- Entrance animation ---------- */
      setupEntrance() {
        const type = this.dataset.entrance;
        if (!type || type === 'none' || this.reduceMotion || !('IntersectionObserver' in window)) return;
        this.classList.add('is-animated');
        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.io.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        this.items.forEach((el) => this.io.observe(el));
      }

      /* ---------- Lightbox ---------- */
      setupLightbox() {
        const d = this.dialog;
        this.lbImg = d.querySelector('[data-ig-lb-img]');
        this.lbCaption = d.querySelector('[data-ig-lb-caption]');
        this.lbCounter = d.querySelector('[data-ig-counter]');
        this.lbPrev = d.querySelector('[data-ig-lb-prev]');
        this.lbNext = d.querySelector('[data-ig-lb-next]');
        const figure = d.querySelector('[data-ig-lb-figure]');
        const stage = d.querySelector('[data-ig-stage]');

        this.addEventListener('click', (e) => {
          const trigger = e.target.closest('[data-ig-open]');
          if (!trigger) return;
          e.preventDefault();
          this.openLightbox(trigger.closest('[data-ig-item]'));
        });

        d.querySelector('[data-ig-close]').addEventListener('click', () => d.close());
        this.lbPrev.addEventListener('click', () => this.showSlide(-1));
        this.lbNext.addEventListener('click', () => this.showSlide(1));

        d.addEventListener('click', (e) => {
          if (e.target === d || e.target === stage) d.close();
        });
        d.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.showSlide(-1);
          if (e.key === 'ArrowRight') this.showSlide(1);
        });
        d.addEventListener('close', () => {
          document.documentElement.style.overflow = '';
          this.lbImg.removeAttribute('src');
        });

        // Swipe
        let startX = null;
        figure.addEventListener('pointerdown', (e) => { startX = e.clientX; });
        figure.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          startX = null;
          if (Math.abs(dx) > 50) this.showSlide(dx < 0 ? 1 : -1);
        });
        figure.addEventListener('pointercancel', () => { startX = null; });
      }

      openLightbox(item) {
        this.lbItems = this.items.filter((el) => !el.hidden && el.querySelector('[data-ig-open]'));
        this.lbIndex = this.lbItems.indexOf(item);
        if (this.lbIndex < 0) return;
        this.showSlide(0);
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
      }

      showSlide(delta) {
        const total = this.lbItems.length;
        if (!total) return;
        this.lbIndex = (this.lbIndex + delta + total) % total;
        const data = this.lbItems[this.lbIndex].querySelector('[data-ig-open]').dataset;

        this.lbImg.src = data.full;
        this.lbImg.alt = data.alt || '';

        const showCaption = this.dataset.captions === 'true' && data.caption;
        this.lbCaption.textContent = showCaption ? data.caption : '';
        this.lbCaption.hidden = !showCaption;

        if (this.lbCounter) this.lbCounter.textContent = `${this.lbIndex + 1} / ${total}`;
        this.lbPrev.hidden = this.lbNext.hidden = total < 2;

        [1, -1].forEach((step) => {
          const neighbour = this.lbItems[(this.lbIndex + step + total) % total];
          const src = neighbour && neighbour.querySelector('[data-ig-open]').dataset.full;
          if (src) new Image().src = src;
        });
      }
    }
    customElements.define('image-gallery', ImageGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
